import * as React from "react";
import { SVGProps } from "react";
const SvgSocialGooglePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.058 5.942c2.628 0 4.627 1.051 6.399 2.345l.23.17-2.972 2.972c-.915-.915-2.286-1.371-3.657-1.371-3.2 0-5.943 2.742-5.943 5.942s2.743 5.942 5.943 5.942c2.661 0 4.678-1.722 5.213-3.913l.044-.2h-5.257v-3.887h9.37c.23.687.23 1.6.23 2.287 0 5.713-3.887 9.829-9.6 9.829C4.57 26.058 0 21.486 0 16S4.571 5.942 10.058 5.942Zm18.513 4.801v3.429H32v2.513h-3.656v3.43H25.83v-3.43h-3.428v-2.513h3.656v-3.429h2.513Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialGooglePlus;
